import React, { FC } from "react";
import {
  Box,
  CssBaseline,
  Theme,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { TelegramIcon } from "../../assets/svg/Home/TelegramIcon";
import { useAuth } from "../../auth/AuthContext";
import { Appbar } from "../Appbar";
import { MainContainer } from "../styledComponents";
import { DotIcon } from "../../assets/svg/Home/DotIcon";
import { ArrowDownIcon } from "../../assets/svg/Home/ArrowDownIcon";

export const Toolbar: FC = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "14px",
        paddingTop: "40px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "14px",
          paddingLeft: "40px",
          paddingRight: "40px",
        }}
      >
        <Typography
          sx={{
            fontSize: 18,
            fontWeight: 700,
            lineHeight: "18px",
            color: "#111926",
          }}
        >
          Refer a Friend, get $500 when they are hired
        </Typography>
        <TelegramIcon />
      </Box>
      <Box
        sx={{
          width: "100%",
          paddingTop: "14px",
          paddingBottom: "20px",
          borderTop: "1px solid rgba(17, 25, 38, 0.1)",
          paddingLeft: "40px",
          paddingRight: "40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          overflow: "hidden",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <Typography
            sx={{
              fontSize: 13,
              fontWeight: 500,
              lineHeight: "13px",
              color: "#A1A5A7",
            }}
          >
            © 2024. All rights reserved.
          </Typography>
          <DotIcon />
          <Typography
            sx={{
              fontSize: 13,
              fontWeight: 500,
              lineHeight: "13px",
              color: "#A1A5A7",
            }}
          >
            Privacy
          </Typography>
          <DotIcon />
          <Typography
            sx={{
              fontSize: 13,
              fontWeight: 500,
              lineHeight: "13px",
              color: "#A1A5A7",
            }}
          >
            Terms
          </Typography>
          <DotIcon />
          <Typography
            sx={{
              fontSize: 13,
              fontWeight: 500,
              lineHeight: "13px",
              color: "#A1A5A7",
            }}
          >
            Sitemap
          </Typography>
          <DotIcon />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Typography
            sx={{
              fontSize: 13,
              fontWeight: 500,
              lineHeight: "13px",
              color: "#A1A5A7",
            }}
          >
            Suport & Resources
          </Typography>
          <ArrowDownIcon />
        </Box>
      </Box>
    </Box>
  );
};
